import { Component } from '@angular/core';
import { SearchType } from '../../models/analys-resultat';

@Component({
    selector: 'app-namnardata-search',
    templateUrl: './namnardata-search.component.html',
    standalone: false
})
export class NamnardataSearchComponent {
  protected readonly searchType = SearchType.NAMNARDATA;
}
